.overlay { position: fixed; inset: 0; z-index: 400; background: var(--scrim); border: none; }
.modal {
  position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 401;
  width: 680px; max-width: 95vw; height: 80vh; display: flex; flex-direction: column;
  background: var(--card-bg); border-radius: var(--r-lg); box-shadow: 0 20px 60px rgba(0,0,0,.25); overflow: hidden;
}
.header { display: flex; align-items: flex-start; gap: 12px; padding: 15px 20px; border-bottom: 1px solid var(--border); }
.header > div { flex: 1; }
.title { font-size: 15px; font-weight: 700; color: var(--text); }
.subtitle { margin-top: 3px; font-size: 13px; color: var(--text2); }
.close { background: none; border: none; font-size: 22px; line-height: 1; color: var(--text2); cursor: pointer; }
.toolbar { display: flex; align-items: center; gap: 10px; padding: 10px 20px; border-bottom: 1px solid var(--border); }
.search {
  flex: 1; padding: 7px 10px; font-size: 12.5px; color: var(--text);
  background: var(--input-bg, var(--card-bg)); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.search:focus, .input:focus { border-color: var(--blue); outline: none; }
.warn { padding: 3px 10px; font-size: 13px; font-weight: 600; color: var(--warn); background: var(--warn-bg); border-radius: var(--r-pill); white-space: nowrap; }
.error { margin: 10px 20px 0; padding: 8px 12px; font-size: 12.5px; color: var(--err); background: var(--err-bg); border-radius: var(--r-sm); }
.body { flex: 1; overflow-y: auto; padding: 0 20px; }
.table { width: 100%; border-collapse: collapse; }
.table th {
  position: sticky; top: 0; z-index: 1; padding: 9px 8px; text-align: left; white-space: nowrap;
  font-size: 12.5px; font-weight: 600;
  color: var(--text2); background: var(--card-bg); border-bottom: 1px solid var(--border);
}
.table td { padding: 6px 8px; font-size: 12.5px; color: var(--text); border-bottom: 1px solid var(--border); }
.missing td:first-child { box-shadow: inset 3px 0 0 var(--warn); }
.num { text-align: right; font-variant-numeric: tabular-nums; }
.muted { color: var(--text2); }
.none { padding: 18px; font-size: 13px; text-align: center; color: var(--text2); }
/* Цвет VLAN — тот же, что на лицевой панели и в карточке коммутатора */
.chip {
  display: inline-block; min-width: 40px; padding: 2px 8px; font-size: 13px; font-weight: 700; text-align: center;
  color: #fff; background: var(--vlan, var(--slate)); border-radius: var(--r-pill); font-variant-numeric: tabular-nums;
}
.input {
  width: 100%; padding: 6px 9px; font: inherit; font-size: 12.5px; color: var(--text);
  background: var(--input-bg, var(--card-bg)); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.input::placeholder { color: var(--text2); opacity: .7; }
.actions { width: 1%; white-space: nowrap; text-align: right; }
.button {
  padding: 6px 12px; font-size: 13px; color: var(--text2); white-space: nowrap;
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-sm); cursor: pointer;
}
.button:hover { border-color: var(--blue); color: var(--blue); }
.button:disabled { opacity: .5; cursor: default; }
.primary { color: #fff; background: var(--blue); border-color: var(--blue); font-weight: 600; }
.primary:hover { color: #fff; background: var(--blue-dark); }
.footer { display: flex; gap: 8px; padding: 12px 20px; border-top: 1px solid var(--border); }
.vidInput { width: 90px; flex-shrink: 0; }
@media (max-width: 640px) {
  .modal { width: 100%; max-width: 100%; height: 100%; border-radius: 0; top: 0; left: 0; transform: none; }
}
